export class EuiDateRangeSelectorDates {
    startRange: Date;
    endRange: Date;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
